import React from 'react';
import Box from 'carbon-react/lib/components/box';

import { NarrativeSummaryCard } from './components/narrative-summary-card/narrative-summary-card';
import { TabDisclaimer } from './tab-disclaimer';
import { MappedExecutiveSummary } from './mappers/types';

interface SummaryTabProps {
  data: MappedExecutiveSummary;
}

export const SummaryTab = ({ data }: SummaryTabProps) => {
  return (
    <Box display="flex" flexDirection="column" gap="16px">
      <NarrativeSummaryCard
        paragraphs={data.paragraphs}
        bottomLine={data.bottomLine}
      />
      <TabDisclaimer />
    </Box>
  );
};
